import Auth from "@aws-amplify/auth";
import { path, pathOr } from "ramda";

export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";

export default {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {
    isAdmin: (state) =>
      pathOr(false, ["user", "attributes", "custom:admin"], state),
    getUser: (state) => state.user,
    getUserEmail: (state) => path(["user", "attributes", "email"], state),
    needsNewPassword: (state) =>
      path(["user", "challengeName"], state) === "NEW_PASSWORD_REQUIRED",
    getIdentityToken: (state) =>
      path(["user", "signInUserSession", "idToken", "jwtToken"], state),
  },
  mutations: {
    [SET_USER](state, user) {
      state.user = user;
    },
    [CLEAR_USER](state) {
      state.user = null;
    },
  },
  actions: {
    async authenticate({ commit }, { email, password }) {
      const user = await Auth.signIn({ username: email, password });
      commit(SET_USER, user);
    },
    async logOut({ commit }) {
      await Auth.signOut();
      commit(CLEAR_USER);
    },
    async changePassword({ dispatch, getters }, { oldPassword, newPassword }) {
      const user = getters.getUser;
      await Auth.changePassword(user, oldPassword, newPassword);
      await dispatch("checkUserSession");
    },
    async setNewPassword({ commit, getters }, { password }) {
      try {
        const user = await Auth.completeNewPassword(getters.getUser, password);
        commit(SET_USER, user);
      } catch (err) {
        // TODO: failed... problem
        console.error(err);
        throw err;
      }
    },
    async checkUserSession({ commit }) {
      try {
        const user = await Auth.currentAuthenticatedUser();
        commit(SET_USER, user);
      } catch (err) {
        // The user is unauthenticated...
        throw new Error(`User is not authenticated`);
      }
    },
    async initForgotPassword(_, email) {
      const { CodeDeliveryDetails } = await Auth.forgotPassword(email);
      return CodeDeliveryDetails;
    },
    async completeForgotPassword(_, { email, password, code }) {
      await Auth.forgotPasswordSubmit(email, code, password);
    },
  },
};
